import { getMonthNames, getNumbers, useTokenValues } from '@jds/react-engine';

import { JDSDatepickerHeaderProps } from './generated/interface';
import { useMemo } from 'react';

export const withLogic =
  (
    Component: React.ComponentType<JDSDatepickerHeaderProps>
  ): React.FC<JDSDatepickerHeaderProps> =>
  (props: JDSDatepickerHeaderProps) => {
    const tokens = useTokenValues();
    const language = tokens.lang;
    const numeralList = useMemo(() => {
      return getNumbers(language);
    }, [language]);
    const getLocaleYear = (year: number) => {
      const yearString = year?.toString();
      return yearString?.replace(
        /\d/g,
        (num) => numeralList[parseInt(num, 10)] ?? num
      );
    };

    const getMonthNamesFromLocale = useMemo(() => {
      return getMonthNames(language);
    }, [language]);
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    return (
      <Component
        {...{
          ...props,
          _monthAriaLabel:
            props.state === 'month'
              ? 'Select month'
              : `${monthNames[Number(props.month)]}, Select month`,
          _yearAriaLabel:
            props.state === 'year'
              ? 'Select year'
              : `${props.year}, Select year`
        }}
        year={getLocaleYear(Number(props.year))}
        month={getMonthNamesFromLocale[Number(props.month)]}
      />
    );
  };
